export const deviceGroupConstants = {
    DEVICE_GROUP_LIST_REQUEST: "DEVICE_GROUP_LIST_REQUEST",
    DEVICE_GROUP_LIST_SUCCESS: "DEVICE_GROUP_LIST_SUCCESS",
    DEVICE_GROUP_LIST_FAILURE: "DEVICE_GROUP_LIST_FAILURE",

    DEVICE_GROUP_BY_ID_REQUEST: "DEVICE_GROUP_BY_ID_REQUEST",
    DEVICE_GROUP_BY_ID_SUCCESS: "DEVICE_GROUP_BY_ID_SUCCESS",
    DEVICE_GROUP_BY_ID_FAILURE: "DEVICE_GROUP_BY_ID_FAILURE",

    DEVICE_GROUP_CLEAR_LIST: "DEVICE_GROUP_CLEAR_LIST",

    DEVICE_GROUP_DROPDOWN_REQUEST: "DEVICE_GROUP_DROPDOWN_REQUEST",
    DEVICE_GROUP_DROPDOWN_SUCCESS: "DEVICE_GROUP_DROPDOWN_SUCCESS",
    DEVICE_GROUP_DROPDOWN_FAILURE: "DEVICE_GROUP_DROPDOWN_FAILURE"
};
